import type { PropsWithChildren } from 'react'
import clsx from 'clsx'
import { ScrollContext } from './ScrollContext'
import { useScroll } from './useScroll'

export function ScrollProvider({ children }: Readonly<PropsWithChildren>) {
  const value = useScroll()

  return (
    <ScrollContext value={value}>
      <div
        data-testid="layout"
        className={clsx({
          'not-scrolled': value.scroll === 0,
          'scrolled': value.scroll > 0,
          'is-scrolling-up': value.isScrollingUp,
          'is-header-hidden': value.hideHeader,
        })}
      >
        {children}
      </div>
    </ScrollContext>
  )
}
